export class ConflictRequestError extends Error {
  constructor(message: string) {
    super(message)
  }
}

export class UnauthorizedRequestError extends Error {
  public readonly isRedirectToValidAP: boolean

  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  constructor(message: string, isRedirectToValidAP: boolean = false) {
    super(message)
    this.name = 'AuthorizationError'
    this.isRedirectToValidAP = isRedirectToValidAP
  }
}

export class BadRequestError extends Error {
  field: string | null

  constructor(message: string, field: string | null) {
    super(message)
    this.field = field
  }
}

export class NotFoundRequestError extends Error {
  constructor(message: string) {
    super(message)
  }
}

export class IdpRequestError extends Error {
  constructor(message: string) {
    super(message)
  }
}

export class GenericRequestError extends Error {
  constructor(message: string) {
    super(message)
  }
}
